import { render, staticRenderFns } from "./supplierCommonAction.vue?vue&type=template&id=ecb73732&scoped=true"
import script from "./supplierCommonAction.vue?vue&type=script&lang=js"
export * from "./supplierCommonAction.vue?vue&type=script&lang=js"
import style0 from "./supplierCommonAction.vue?vue&type=style&index=0&id=ecb73732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb73732",
  null
  
)

export default component.exports